import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE, deleteErrorMsg, deleteMsg,
    error, LIST,
    NO, warning, YES,
} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {confirmAlert} from "react-confirm-alert";
import {utilHelper} from "../../../jwt/_helpers";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {ButtonTableDelete} from "../../../components/buttons/buttonsActions";
import {showLoader} from "../../../components/loader/loader";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {geoPickupService} from "../../../jwt/_services/configuration/geoPickupService";

export const GeoPickupList = forwardRef((props, ref) => {

    const [pickup] = useState(props.pickup);

    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(10);

    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        refreshDataList(page, currentIndex, sizePerPage);
    }, []);

    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage
        refreshDataList(page, index, sizePerPage);
    };

    const refreshDataList = (page, currentIndex, sizePerPage) => {
        setLoading(true);
        setListItems([]);

        geoPickupService.search(currentIndex, sizePerPage, pickup)
            .then(result => {
                if (result){
                    setListItems(result);
                    setTotalSize(0);
                    setCurrentIndex(1);
                    setPage(1);
                    setSizePerPage(10);
                } else {
                    setListItems([]);
                    setTotalSize(0);
                    setCurrentIndex(1);
                    setPage(1);
                    setSizePerPage(10);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                setTotalSize(0);
                setCurrentIndex(1);
                setPage(1);
                setSizePerPage(10);
                showToastCustom(error, errorMessage);
            });
    }

    useImperativeHandle(ref, () => ({
        refreshList() {
            refreshDataList(page, currentIndex, sizePerPage);
        }
    }));

    // ----------------------------------------------
    //            TABLE BUTTONS
    // ----------------------------------------------
    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        geoPickupService.deleteItem(data.id)
            .then(_ => {
                setLoading(false);
                refreshDataList();
                if (utilHelper.hasAssociateRecords()) {
                    showToastCustom(error, deleteErrorMsg, true);
                    utilHelper.restartAssociateRecords();
                } else {
                    showToastCustom(warning, deleteMsg, true);
                }
            });
    }

    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.editItem(true, itemToEdit);
    }

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------
    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <ButtonTableDelete onClick={() => confirmDelete(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'Firebase Id',
        headerStyle: {width: '100px'},
        sort: true
    }, {
        dataField: 'hotelId',
        text: 'Id de Hotel',
        headerStyle: {width: '50px'},
        sort: true
    }, {
        dataField: 'timeId',
        text: "Id de horario",
        headerStyle: {width: '50px'}
    }, {
        dataField: 'status',
        text: "Activo",
        headerStyle: {width: '50px'},
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '20%'},
        formatter: actionsFormatter
    }
    ];

    return (
        <div>
            {loading && showLoader()}
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                </CardTitle>
                <CardBody className="">
                    {loading && showLoader()}
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listItems}
                        columns={columns}
                        pagination={paginationFactory({page, sizePerPage, totalSize})}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
        </div>
    )
})